module.exports = __webpack_public_path__ + "img/8.3436dcb9.jpg";